/* @flow */
export const SET_NEW_FARE_ESTIMATE_USE_CASE = '@fare-estimates/SET_NEW_FARE_ESTIMATE_USE_CASE';
export const SET_NEW_FARE_ESTIMATE_ORIGIN_ID = '@fare-estimates/SET_NEW_FARE_ESTIMATE_ORIGIN_ID';
export const SET_NEW_FARE_ESTIMATE_DESTINATION_ID =
  '@fare-estimates/SET_NEW_FARE_ESTIMATE_DESTINATION_ID';



// WEBPACK FOOTER //
// ./src/redux/fare-estimates/actionTypes.js